import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { AppVersionForm } from '@/components/forms/AppVersionForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function EditAppVersionPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { id } = useParams()
  const appVersionId = Number(id)

  if (!id || Number.isNaN(appVersionId)) {
    navigate('/system-settings/app-versions')
    return null
  }

  return (
    <AdminLayout>
      <Box p={4}>
        <Card>
          <CardHeader>
            <Heading size="md">Edit App Version</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>Update version metadata and rollout settings</Text>
          </CardHeader>
          <CardBody>
            <AppVersionForm
              appVersionId={appVersionId}
              onSuccess={() => navigate('/system-settings/app-versions')}
              onCancel={() => navigate('/system-settings/app-versions')}
            />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
